import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./global.css";
import "@fontsource/jim-nightshade";
import { BrowserRouter } from "react-router-dom";
import { CartProvider } from "./Context/CartContext.jsx";
import { AuthProvider } from "./Context/AuthContext.jsx";

createRoot(document.querySelector("#root")).render(
  <BrowserRouter>
    <AuthProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </AuthProvider>
  </BrowserRouter>,
);
